// 1 minute
export const WIDGET_REFETCH_INTERVAL = 60000;
